import { MERCHANT_ONBOARDING_FIRST_PATH } from '../routes/merchantOnboardingStages';

/**
 * Map API redirect_page (kebab-case) to frontend onboarding path.
 * dashboard and set-password are not onboarding routes; they are not included.
 */
export const REDIRECT_PAGE_TO_PATH = {
  'administrative-billing-details': '/onboarding/administrative_billing_details_submitted',
  'contract-sign': '/onboarding/contract_signed',
  payment: '/onboarding/payment',
};

/**
 * Returns the frontend path to redirect to for the pending onboarding step, or null.
 * Used after login/reset password when onboarding_steps.all_completed is false.
 *
 * @param {Object} onboardingSteps - onboarding_steps from API (data.data.onboarding_steps or resetData.onboarding_steps)
 * @returns {string|null} Full path to redirect to, or null if no onboarding redirect
 */
export function getOnboardingRedirectPath(onboardingSteps) {
  // eslint-disable-next-line no-debugger
  // debugger;
  if (!onboardingSteps || onboardingSteps.all_completed === true) {
    return null;
  }

  const { steps } = onboardingSteps;
  const pendingStep = onboardingSteps.pending_step;

  let stepToUse = pendingStep;
  if (pendingStep && pendingStep.required === false && Array.isArray(steps)) {
    const firstRequiredPending = steps.find(
      (s) => s.required === true && (s.status === 'pending' || s.status === 'Pending'),
    );
    if (firstRequiredPending) {
      stepToUse = firstRequiredPending;
    }
  }

  if (!stepToUse || !stepToUse.redirect_page) {
    return null;
  }

  const path = REDIRECT_PAGE_TO_PATH[stepToUse.redirect_page];
  // Stale pending_step can still say "payment" after checkout; never send user back once payment step is done
  if (path === REDIRECT_PAGE_TO_PATH.payment) {
    const paymentStep = steps?.find((s) => s?.key === 'payment');
    const pst = String(paymentStep?.status || '').toLowerCase();
    if (pst === 'completed' || pst === 'complete') {
      return null;
    }
  }
  return path || null;
}

/**
 * Check if payment step is required based on onboarding_steps.
 * @param {Object} onboardingSteps - onboarding_steps from API/Redux
 * @returns {boolean} - true if payment is needed, false if skipped/not required
 */
export function isPaymentStepRequired(onboardingSteps) {
  if (!onboardingSteps?.steps || !Array.isArray(onboardingSteps.steps)) return true;
  const paymentStep = onboardingSteps.steps.find((s) => s?.key === 'payment');
  if (!paymentStep) return true;
  if (paymentStep.required === false || paymentStep.status === 'skipped') return false;
  const st = String(paymentStep.status || '').toLowerCase();
  if (st === 'completed' || st === 'complete') return false;
  return true;
}

export { MERCHANT_ONBOARDING_FIRST_PATH };
